import { Chip, Tooltip } from '@mui/material';
import { printStatusMeta } from '../../utils/printerState.mjs';

export default function PrintStatusChip({ status, errorMessage, size = 'small' }) {
  const meta = printStatusMeta(status);
  const chip = <Chip size={size} color={meta.color} variant="outlined" label={meta.label} />;
  return errorMessage ? <Tooltip title={errorMessage}>{chip}</Tooltip> : chip;
}
